export function reportPeriodRange(
  period,
  { month, half, from, to, currentDay }
) {
  const validDay = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return false;
    const date = new Date(value + "T00:00:00Z");
    return (
      Number.isFinite(date.getTime()) &&
      date.toISOString().slice(0, 10) === value
    );
  };
  if (period === "to-date") {
    if (!validDay(currentDay)) throw new Error("Fecha actual inválida.");
    return { desde: currentDay.slice(0, 7) + "-01", hasta: currentDay };
  }
  if (period === "custom") {
    if (!validDay(from) || !validDay(to))
      throw new Error("Indique las fechas Desde y Hasta.");
    if (from > to) throw new Error("Desde no puede ser posterior a Hasta.");
    return { desde: from, hasta: to };
  }
  if (
    !/^\d{4}-(0[1-9]|1[0-2])$/.test(month || "") ||
    Number(month.slice(0, 4)) < 1000
  )
    throw new Error("Seleccione un mes válido.");
  const [year, number] = month.split("-").map(Number);
  const lastDay = new Date(Date.UTC(year, number, 0)).getUTCDate();
  if (period === "monthly")
    return { desde: month + "-01", hasta: month + "-" + lastDay };
  if (period === "fortnight" && ["1", "2"].includes(half))
    return {
      desde: month + (half === "1" ? "-01" : "-16"),
      hasta: month + "-" + (half === "1" ? "15" : lastDay),
    };
  throw new Error("Seleccione un período válido.");
}
